export default {"src":"/_next/static/media/StrokeBrainHemorrhage.b78ddd0d.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};